import numeral from 'numeral';
import PageHeader from '../components/PageHeader';
import { Badge, Box, Divider, Flex, Heading, Text } from '@chakra-ui/react';
import { format } from 'date-fns';

const TransactionDetail = () => {
  return (
    <>
      <PageHeader title='Transaction Details ' />
      <Box pl={5} pr={4} py={3} mt='75px'>
        <Heading as='h5' size='sm' ml={1}>
          Information
        </Heading>

        <Box borderWidth='1px' borderRadius='xl' background='#fff' mt={5}>
          <Flex
            justify='space-between'
            alignItems='center'
            height={14}
            pl={3}
            pr={2}
          >
            <Text color='#94a3b8' fontWeight='semibold'>
              Amount
            </Text>

            <Badge
              colorScheme='green'
              fontSize='medium'
              textTransform='capitalize'
              px={2}
              py={0.5}
              borderRadius='md'
            >
              Ksh. {numeral(13400).format('0,0')}
              <sup>{numeral(13400).format('.00')}</sup>
            </Badge>
          </Flex>
          <Divider />
          <Flex
            justify='space-between'
            alignItems='center'
            height={14}
            pl={3}
            pr={2}
          >
            <Text color='#94a3b8' fontWeight='semibold'>
              Status
            </Text>
            <Text color='#1e40af' fontWeight='semibold'>
              completed
            </Text>
          </Flex>
          <Divider />
          <Flex
            justify='space-between'
            alignItems='center'
            height={14}
            pl={3}
            pr={2}
          >
            <Text color='#94a3b8' fontWeight='semibold'>
              Date
            </Text>
            <Text color='#1e40af' fontWeight='semibold'>
              {format(new Date(), 'do MMM yyyy, p')}
            </Text>
          </Flex>
          <Divider />
          <Flex
            justify='space-between'
            alignItems='center'
            height={14}
            pl={3}
            pr={2}
          >
            <Text color='#94a3b8' fontWeight='semibold'>
              Transaction ID
            </Text>
            <Text color='#1e40af' fontWeight='semibold'>
              UQ3456-567-454K
            </Text>
          </Flex>
          <Divider />
          <Flex
            justify='space-between'
            alignItems='center'
            height={14}
            pl={3}
            pr={2}
          >
            <Text color='#94a3b8' fontWeight='semibold'>
              Type
            </Text>
            <Text color='#1e40af' fontWeight='semibold'>
              Disbursement
            </Text>
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default TransactionDetail;
